<template>
  <div>
    <div class="mv-slider__small__item--cont">
      <div class="slide_title">{{ sliderSmallChild.title }}</div>
      <div class="img-slider__small">
        <img :src="$func.formatUrl(sliderSmallChild.image)" :alt="sliderSmallChild.title" />
      </div>
      <div class="slide_text">
        <p class="slide_content" v-html="sliderSmallChild.slide_content"></p>
        <div class="slide_note harumi-font" v-if="sliderSmallChild.slide_note !== ''">
          {{ formatNumber(sliderSmallChild.slide_note) }}<span>kWh</span>
        </div>
        <div class="slide_note harumi-font note_custom" v-if="sliderSmallChild.slide_note === ''">
          データ更新中
        </div>
      </div>
    </div>
      <!-- <router-link class="bg-cont" to="/coming-soon">
        <span>Coming Soon <br> 準備中</span>
      </router-link> -->
  </div>
</template>

<script>
import { formatNumber } from '@/utils/helper';

export default {
  name: "SliderSmall",
  props: {
    sliderSmallChild: {
      type: Object,
    },
  },
  components: {},

  methods: {
    formatNumber
  },

  computed: {},
};
</script>